class Element {
  constructor(next, prev, photo) {
    this.next = next;
    this.photo = photo;
  }
}

export default Element;
